import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import useStyles from './styles';

const Error = () => {
  const classes = useStyles();
  return (
    <div className={classes.iconWrapper}>
      <FontAwesomeIcon icon={faExclamationCircle} />
    </div>
  );
};

export default Error;
